import React, { createContext, useContext, useState, useCallback } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography } from '@mui/material';
import { X } from 'lucide-react';
import PolygonSyncCard from '@/ui/tools/PolygonSyncCard';

type PolygonSyncDialogContextValue = {
  open: boolean;
  openDialog: () => void;
  closeDialog: () => void;
};

const PolygonSyncDialogContext = createContext<PolygonSyncDialogContextValue | null>(null);

export function PolygonSyncDialogProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);

  return (
    <PolygonSyncDialogContext.Provider value={{ open, openDialog, closeDialog }}>
      {children}
      <Dialog
        open={open}
        onClose={closeDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
          <Typography variant="h6" fontWeight={600}>ArcGIS Polygon Sync</Typography>
          <IconButton size="small" onClick={closeDialog} sx={{ color: 'text.secondary' }}>
            <X size={18} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <PolygonSyncCard />
        </DialogContent>
      </Dialog>
    </PolygonSyncDialogContext.Provider>
  );
}

export function usePolygonSyncDialog() {
  const ctx = useContext(PolygonSyncDialogContext);
  if (!ctx) {
    return { open: false, openDialog: () => {}, closeDialog: () => {} };
  }
  return ctx;
}
